import { render, staticRenderFns } from "./ClientEmails.vue?vue&type=template&id=4b95f968&scoped=true&"
import script from "./ClientEmails.vue?vue&type=script&lang=js&"
export * from "./ClientEmails.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmails.vue?vue&type=style&index=0&id=4b95f968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95f968",
  null
  
)

export default component.exports